import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DatasourceDomain, OrgTypes } from '@mode/shared/contract-common';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';

/* eslint-disable @nx/workspace/enforce-change-detection-on-push */
@Component({
  selector: 'mode-nav-definitions',
  templateUrl: './nav-definitions.component.html',
  styleUrls: ['./nav-definitions.component.scss'],
})
export class NavDefinitionsComponent implements OnChanges {
  @Input() currentOrg?: OrgTypes.Organization;
  @Input() datasources?: readonly DatasourceDomain.Datasource[];
  @Input() isDatasourcesLoading?: boolean;
  @Input() target?: string;

  isAnalystStudio$ = this.thoughtspotIntegrationService.currOrgIntegrated$;
  filteredDatasources: readonly DatasourceDomain.Datasource[] = [];
  showAllDatasources = false;
  datasourceLimit = 4;

  constructor(private thoughtspotIntegrationService: ThoughtspotIntegrationService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['datasources']?.currentValue) {
      this.filteredDatasources = changes['datasources'].currentValue?.filter(
        (datasource: DatasourceDomain.Datasource) =>
          this.currentOrg?.user ? datasource.public === true : datasource.public === false
      );
    }
  }

  moreText() {
    if (this.filteredDatasources?.length) {
      return this.showAllDatasources ? 'Hide' : `Show ${this.filteredDatasources.length - this.datasourceLimit} more`;
    }

    return undefined;
  }
}
